/* eslint-disable */
import React, { Component } from 'react'
import { MainContainer } from './styledComponents'

export default class PunePageResponsiveContainer extends Component {
  render() {
    const { children, className, id } = this.props
    return (
      <MainContainer id={id} className={className}>
        {children}
      </MainContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/core/PunePageResponsiveContainer/index.js